export enum OrderDeclineReason {
  ADDRESSEE_NOT_IN_DEPARTMENT = 'ADDRESSEE_NOT_IN_DEPARTMENT',
  ADDRESSEE_LEFT_DEPARTMENT = 'ADDRESSEE_LEFT_DEPARTMENT',
  ADDRESSEE_IS_FREE = 'ADDRESSEE_IS_FREE',
  DECLINE_BY_ALOE = 'DECLINE_BY_ALOE',
  DECLINE_BY_MODERATOR = 'DECLINE_BY_MODERATOR',
  NO_ITEMS_IN_STORE = 'NO_ITEMS_IN_STORE',
}
